var React = require('react');

function Import (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 44l0 3.5c0 5.8 4.7 10.5 10.5 10.5l35 0c5.8 0 10.5-4.7 10.5-10.5l0-3.5m-14-14l-14 14m0 0l-14-14m14 14l0-42","style":{"fill":"none"}}));
}

Import.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Import;

Import.default = Import;
